import { styled } from '@mui/material/styles';
import { DialogTitle } from '@mui/material';

export const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: 'bold',
  textAlign: 'center',
});
